import moment from 'moment';
import { toClock } from '@/utils';

export class StatisticsService {
  public statisticToChartData(statistics: any[]) {
    const chartData = statistics.map(period => {
      const raw = this.calculatePeriodTime(period);
      const hours = Math.floor(raw / 60);
      const minutes = raw % 60;
      return [`${period.start} -  ${period.end}`, hours, this.parseTime({ hours, minutes })];
    });
    return [['Dzień', 'Godziny', { role: 'annotation' }], ...chartData];
  }

  private calculatePeriodTime(period: any) {
    this.setTodayEnd(period);
    return period.days.reduce((total: number, day: any) => this.addDayToTotal(total, day), 0);
  }

  private setTodayEnd(period: any) {
    const now = moment();
    const currentDay = period.days.find((day: any) => this.isCurrentDay(day));
    if (currentDay) {
      currentDay.end = now.hours() * 60 + now.minutes();
    }
  }

  private isCurrentDay(day: any) {
    return day.date === moment().format('YYYY-MM-DD') && day.end === null;
  }

  private addDayToTotal(total: number, day: any) {
    if (day.end && day.start) {
      return total + day.end - day.start;
    }
    return total;
  }

  private parseTime(time: any) {
    return `${toClock(time.hours)}:${toClock(time.minutes)}`;
  }
}

export default new StatisticsService();
